import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { HeroSection } from '@/components/home/HeroSection';
import { HistorySection } from '@/components/home/HistorySection';
import { TrustMarquee, NumbersProof, DualAudience, HowItWorks, BentoFeatures } from '@/components/home/FeaturesSection';
import { ServicesSection } from '@/components/home/ServicesSection';
import { LoadBoardCTA } from '@/components/home/LoadBoardCTA';
import { CustomerPortalSection } from '@/components/home/CustomerPortalSection';
import { CertificationsSection } from '@/components/home/CertificationsSection';
import { QuoteCalculatorCTA, IndustriesSection, TestimonialsSection } from '@/components/home/IndustriesAndTestimonials';
import { NewsletterSection } from '@/components/home/NewsletterSection';
import { HotLanesStrip } from '@/components/HotLanesStrip';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePage = () => {
  const [stats, setStats] = useState(null);
  const [email, setEmail] = useState('');
  const [subscribing, setSubscribing] = useState(false);

  const fetchStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/stats`);
      setStats(response.data);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error fetching stats:', error);
      }
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setSubscribing(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch {
      toast.error('Failed to subscribe. Please try again.');
    } finally {
      setSubscribing(false);
    }
  };

  return (
    <div className="overflow-hidden">
      <HeroSection stats={stats} />
      <HistorySection />
      <TrustMarquee />
      <NumbersProof />
      <DualAudience />
      <HowItWorks />
      <BentoFeatures />
      <ServicesSection />
      <QuoteCalculatorCTA />
      <LoadBoardCTA />
      <HotLanesStrip theme="dark" />
      <CustomerPortalSection />
      <IndustriesSection />
      <TestimonialsSection />
      <CertificationsSection />
      <NewsletterSection
        email={email}
        setEmail={setEmail}
        subscribing={subscribing}
        onSubmit={handleNewsletterSubmit}
      />
    </div>
  );
};

export default HomePage;
